<template>
  <div class="contract-navigation border-top mx-2">
    <div class="row py-3">
      <div class="col">
        <div v-if="hasPreviousContract" class="contract-navigation__move">
          <h1
            class="fa fa-caret-square-left color-gray-7 mt-1 mt-md-0 mt-sm-1"
            @click="$emit('previous')"
          />
          <span
            class="
              color-gray-7
              font-16 font-weight-bold
              ml-3
              mt-n2
              d-block d-md-block d-sm-none
            "
          >
            Contrato Anterior
          </span>
        </div>
      </div>
      <div class="col text-center pt-1 pt-md-2 pt-sm-1">
        <div
          class="
            d-flex
            align-items-center
            justify-content-center
            contract-navigation__paging
          "
        >
          <div class="contract-navigation__paging__input">
            <custom-input
              id="contract-navigation-input"
              :max="totalContracts"
              :min="1"
              type="number"
              :value="contractIndex"
              @input="onChangeContractIndex"
              @keypress.enter="onEnterContractIndex"
            />
          </div>
          <div
            class="
              bg-gray-5
              px-4
              cursor-pointer
              d-flex
              justify-content
              align-items-center
              color-green
              font-14 font-weight-bold
              rounded-right
              contract-navigation__paging__total
            "
          >
            {{ totalContracts }}
          </div>
        </div>
      </div>
      <div class="col text-right">
        <div
          v-if="hasNextContract"
          class="contract-navigation__move justify-content-end"
        >
          <span
            class="
              color-gray-7
              font-16 font-weight-bold
              mt-n2
              mr-3
              d-block d-md-block d-sm-none
            "
          >
            Contrato Siguiente
          </span>
          <h1
            class="fa fa-caret-square-right color-gray-7 mt-1 mt-md-0 mt-sm-1"
            @click="$emit('next')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';

export default {
  name: 'ContractNavigation',
  components: {
    CustomInput,
  },
  props: {
    hasPreviousContract: {
      type: Boolean,
      default: () => false,
    },
    hasNextContract: {
      type: Boolean,
      default: () => false,
    },
    contractIds: {
      type: Array,
      default: () => [],
    },
    currentContractId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      contractIndex: null,
    };
  },
  computed: {
    totalContracts() {
      return this.contractIds.length;
    },
  },
  methods: {
    onEnterContractIndex() {
      const id = this.contractIds[this.contractIndex - 1];
      if (id > 0) this.$emit('current', id);
    },
    onChangeContractIndex(value) {
      this.contractIndex =
        value > this.totalContracts ? this.totalContracts : value;
      this.onEnterContractIndex();
    },
  },
  watch: {
    currentContractId: {
      immediate: true,
      handler(value) {
        this.contractIndex = this.contractIds.findIndex((x) => x === value) + 1;
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.contract-navigation {
  &__move {
    display: flex;
    align-items: center;
    h1 {
      cursor: pointer;
    }
  }
  &__paging {
    &__input {
      input {
        height: 36px;
        width: 62px;
        border: unset;
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        padding: 1px;
        border: 1px solid map-get($colors, 'gray-5');
        text-align: center;
        &:focus {
          outline: none !important;
        }
      }
    }
    &__total {
      height: 38px;
    }
  }
}
</style>
